import * as React from 'react';

import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

const SignupModal = ({ closeModal, goToSignup, }) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  return (
    <div>
      <div className="signup-modal-background" onClick={closeModal} />
      <div
        aria-labelledby="signup-modal-title"
        aria-modal="true"
        className="signup-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h2 id="signup-modal-title">Sign Up to Customize this Lesson</h2>
        <p>In order to customize this lesson, you need to sign up to Quill! Once you have signed up, you can input your own prompts and activities to tailor the lesson to the needs and interests of your students.</p>
        <div className="signup-modal-buttons">
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <div className="signup-modal-buttons-right">
            <a className="quill-button outlined medium green focus-on-light" href={`${window.postbuildEnv.DEFAULT_URL}/session/new`}>Already have an account? Login</a>
            <button className="quill-button contained medium green focus-on-light" onClick={goToSignup} type="button">Sign up for Quill</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignupModal
